import * as React from "react";
import {
  Box,
  Grid,
} from "@material-ui/core";
import * as styles from "./styles.scss";
import { themeVariables } from "..";
import { MUITooltip } from "../Tooltip";
import { fullWidth } from "../../../../pageComponents/CardTitleHeader/styles.scss";
import classNames from "classnames";

interface IProps {
  nolabel?: boolean;
  label?: any;
  smallLabel?: boolean;
  boldLabel?: boolean;
  shortLabel?: boolean;
  nohint?: boolean;
  hint?: any;
  hintAlign?: "flex-start" | "flex-end" | "center";
  control?: any;
  caption?: string | {__html: string};
  cssModifier?: "lowMargin" | "noMargin";
  children?: any;
  fullWidth?: boolean;
  className?: string;
}

export const FormSettingsRow = (props: IProps) => {
  return (
    <Box className={`${styles.row} ${styles[props.cssModifier]} ${props.className || ''}`}>
      <Grid container>
        {!props.nolabel ? (
          <Grid item xs={12} sm="auto">
            <Box
              className={
                classNames(
                  styles.label,
                  {
                    [styles.labelNotFullWidth]: !fullWidth,
                    [styles.labelEmpty]: !props.label,
                    [styles.labelSmall]: props.smallLabel,
                    [styles.labelShort]: props.shortLabel,
                  })
              }
            >
              <span className={props.boldLabel ? styles.boldLabel : ''}>{props.label}</span>
            </Box>
          </Grid>
        ) : null}
        <Grid
          item
          container
          xs={12}
          sm
          zeroMinWidth
          className={styles.fields}
          justifyContent={props.nohint && props.nolabel ? "center" : "flex-start"}
        >
          {props.nohint ? (
            props.children
          ) : (
            <Grid
              container
              wrap="nowrap"
              alignItems={props.hintAlign || "center"}
            >
              <Box clone alignSelf="center">
                <Grid item xs zeroMinWidth>
                  {props.children}
                  {props.caption ? 
                    typeof props.caption === 'string' ? (
                    <Box
                      className={styles.caption}
                      color={themeVariables.palette.grey[600]}
                    >
                      {props.caption}
                    </Box>
                  ) : <Box
                        className={styles.caption}
                        color={themeVariables.palette.grey[600]}
                        dangerouslySetInnerHTML={props.caption}
                      /> : null}
                </Grid>
              </Box>
              <Grid item>
                <Box
                  className={`${styles.hints} ${props.hint ? "" : styles.hintsEmpty
                    }`}
                >
                  {props.hint ? 
                    typeof props.hint === 'string'
                     ? <MUITooltip placement="top" title={props.hint} dark />
                     : props.hint
                   : null}
                  {props.control}
                </Box>
              </Grid>
            </Grid>
          )}
 
        </Grid>
      </Grid>
    </Box>
  );
};
